import './src/styles/style.scss'
import 'typeface-ubuntu'
import { getConsent, loadGtag, trackPageView } from './src/utils/analytics'

// Google Analytics n'est chargé que si le visiteur a déjà donné son accord.
export const onClientEntry = () => {
  if (getConsent() === 'granted') loadGtag()
}

export const onRouteUpdate = ({ location }) => {
  // Laisse React Helmet mettre à jour le titre avant l'envoi de la page vue.
  setTimeout(() => trackPageView(location.pathname + location.search + location.hash), 50)
}
